import { Component, Input } from '@angular/core';
import { checkPasswordRules, PasswordRuleState } from 'app/validator/password-rules';

@Component({
  standalone: false,
  selector: 'app-password-rules',
  templateUrl: './password-rules.component.html',
  styleUrls: ['./password-rules.component.scss']
})
export class PasswordRulesComponent {
  @Input() password = '';
  // Nutzerdaten für die Ähnlichkeitsregel; null blendet die Regel aus (dann prüft nur der Server)
  @Input() similarTo: string[] | null = null;

  get state(): PasswordRuleState {
    return checkPasswordRules(this.password, this.similarTo);
  }
}
